import { render, staticRenderFns } from "./O2OCustom.vue?vue&type=template&id=546c7a96&scoped=true"
import script from "./O2OCustom.vue?vue&type=script&lang=js"
export * from "./O2OCustom.vue?vue&type=script&lang=js"
import style0 from "./O2OCustom.vue?vue&type=style&index=0&id=546c7a96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546c7a96",
  null
  
)

export default component.exports